import React from "react";

const Sorteos = () => {
  const premios = [
    { emoji: "🎁", premio: "Smart TV JVC de 32”", ganador: "Fam_SP" },
    { emoji: "🔥", premio: "Fire TV Stick (3ra Generación)", ganador: "CasaRoAr" },
    { emoji: "✨", premio: "3 meses gratis de servicio", ganador: "KarolCS17" },
    { emoji: "🏆", premio: "Cliente con más meses adquiridos", ganador: "Fam_SP", extra: "3 meses gratis de servicio" },
    { emoji: "🤝", premio: "Cliente con más referidos", ganador: "Jenami2023", extra: "3 meses gratis de servicio" },
    { emoji: "🎖", premio: "Cliente con más meses acumulados antes de la promoción", ganador: "Hequelor", extra: "1 mes gratis" },
    { emoji: "🌟", premio: "Cliente con más referidos acumulados antes de la promoción", ganador: "VICxio1966", extra: "1 mes gratis" },
    { emoji: "🎁", premio: "Premio de consolación", ganador: "Eddiear71", extra: "1 mes de servicio por ₡1,375" },
  ];

  const cumpleaños = [
    { mes: "Enero", ganador: "ANDREW1987" },
    { mes: "Febrero", ganador: "CasaRoAr" },
    { mes: "Marzo", ganador: "PradoGonzalez" },
    { mes: "Abril", ganador: "AnaSaEs" },
    { mes: "Mayo", ganador: "jmadrigalq" },
    { mes: "Junio", ganador: "Varcas2024" },
    { mes: "Julio", ganador: "Mariana_79" },
    { mes: "Agosto", ganador: "EDWARDVL" },
    { mes: "Septiembre", ganador: "Mike15" },
    { mes: "Octubre", ganador: "Fam_RoQS10" },
    { mes: "Noviembre", ganador: "VICxio1966" },
    { mes: "Diciembre", ganador: "tacsane" },
  ];

  const primerosDiez = [
    "jcespedesc",
    "Estebanrc03",
    "Mariana_79",
    "Hmoraz",
    "Jroblesf",
    "FamRivAra",
    "ValentinaS2013",
    "ShirleyBU",
    "EDWARDVL",
    "DiegoyAdela",
  ];

  return (
    <section className="max-w-4xl mx-auto p-6 bg-gray-100 shadow-lg rounded-lg mt-6">
      {/* Encabezado */}
      <h2 className="text-3xl font-bold text-blue-600 text-center">🎉 Resultados de la Promoción 🎉</h2>
      <p className="text-center text-gray-700 mt-2 mb-6">¡Celebramos Gracias a Ti! - Publicado el 6 de enero de 2025</p>

      {/* Premios Principales */}
      <div className="grid md:grid-cols-2 gap-4">
        {premios.map((item, index) => (
          <div key={index} className="bg-white shadow-md p-4 rounded-lg">
            <h3 className="text-xl font-semibold flex items-center">
              {item.emoji} {item.premio}
            </h3>
            <p className="text-gray-600">Ganador: <span className="font-bold text-blue-500">{item.ganador}</span></p>
            {item.extra && <p className="text-sm text-gray-500">Premio adicional: {item.extra}</p>}
          </div>
        ))}
      </div>

      {/* Tabla de Cumpleaños */}
      <div className="mt-8">
        <h3 className="text-xl font-semibold text-blue-600 mb-2">🎂 Rifa especial de cumpleaños</h3>
        <p className="text-gray-600 mb-4">Cada ganador recibe un mes de servicio por solo ₡1,375 (75% de descuento).</p>
        <div className="overflow-x-auto">
          <table className="w-full bg-white shadow-md rounded-lg">
            <thead>
              <tr className="bg-blue-600 text-white">
                <th className="px-4 py-2">Mes</th>
                <th className="px-4 py-2">Ganador</th>
              </tr>
            </thead>
            <tbody>
              {cumpleaños.map((item, index) => (
                <tr key={index} className="border-t">
                  <td className="px-4 py-2 text-center">{item.mes}</td>
                  <td className="px-4 py-2 text-center font-bold text-blue-500">{item.ganador}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Premio Especial para los 10 Primeros */}
      <div className="mt-8">
        <h3 className="text-xl font-semibold text-blue-600">🎉 Premio especial para los 10 primeros en completar el formulario</h3>
        <p className="text-gray-600 mb-4">Cada uno recibe un mes de servicio por solo ₡4,125 (25% de descuento).</p>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 bg-white p-4 shadow-md rounded-lg">
          {primerosDiez.map((nombre, index) => (
            <span key={index} className="text-gray-700 font-bold text-center">{nombre}</span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Sorteos;
